import { Injectable } from "@angular/core";
import { Adapter } from "../adapters/adapters";

export class Activations {
  constructor(
    public contractNo: number,
    public count: number,
    public product: string,
    public code: string,
    public comment: string,
    public hostname: string,
    public timestamp: any,
    public action: string,
    public selected = false,
    public licType: string,
    public activationType: string,
    public expiry: Date | null,
    public dateSurrendered: Date | null,
    public ipAddress: string,
    public signature: string,
    public attribute: string,
    public machineType: string,
    public platform: string,
    public siteLicence: boolean,
  ) {}
}

@Injectable({
  providedIn: "root",
})
export class ActivationsAdapter implements Adapter<Activations> {
  adapt(item: any): Activations {
    return new Activations(
      item.contractNo,
      item.count,
      item.product,
      item.code,
      item.comment,
      item.hostname,
      item.timestamp,
      item.action,
      item.selected,
      item.licType,
      item.activationType,
      item.expiry ? new Date(item.expiry) : null,
      item.dateSurrendered ? new Date(item.dateSurrendered) : null,
      item.ipAddress,
      item.signature,
      item.attribute,
      item.machineType,
      item.platform,
      item.siteLicence === true,
    );
  }
}

export class ActivationItem {
  contractNo: number;
  count: number;
  product: string;
  code: string;
  comment: string;
  hostname: string;
  timestamp: any;
  action: string;
  selected: boolean;
  expiry: Date;
}

export class ActivateLicense {
  "product": string;
  "machineType": string; //physical/virtual
  "attribute": string; // server/desktop
  "platform": string;
  "ip": string;
  "hostname": string;
  "signature": string;
  "comment": string;
}

export class ActivationResponse {
  "ipAddr": string;
  "hostname": string;
  "code": string;
}
